import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SingleBenefitsModule } from './benefits/single-benefits.module';
import { TabProfilesModule } from './tab-profiles/tab-profiles.module';
import { TabBenefitsModule } from './tab-benefits/tab-benefits.module';
import { AddProfileModule } from './add-profile/add-profile.module';
import { ProfileTableModule } from './profile-table/profile-table.module';
import { AddCategoryModule } from './add-category/add-category.module';
import { AddBenefitModule } from './add-benefit/add-benefit.module';
import { PlansModule } from './planes/planes.module';
import { TabRequestsModule } from './tab-requests/tab-requests.module';
import { AddUserModule } from './add-user/add-user.module';




@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [],
  imports: [
    SingleBenefitsModule,
    TabProfilesModule,
    TabBenefitsModule,
    TabRequestsModule,
    AddProfileModule,
    ProfileTableModule,
    AddCategoryModule,
    AddBenefitModule,
    PlansModule,
    AddUserModule
  ],
  exports: [],
})
export class WorkflowModule {}